export default __webpack_public_path__ + "static/media/kuvik_art.982d98c6.png";